// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.js"
import { OperationType } from "../../Utils/Trading/OperationType.ts"
import { UrlUtils } from "../../Utils/UrlUtils.js"

export let Idea = function (msg, ins, tradingSystem)
{
    this.name = tradingSystem.name
    this.companyName = tradingSystem.companyName
    this.logoSrcBytes = tradingSystem.logoBytes
    this.tradingSystemId = msg.TradingSystemId

    this.title = msg.Title
    this.description = msg.Description
    // this.descriptionParsed = Utils.ParseTextForURL(this.description)
    this.descriptionParsedToHTML = this.UrlifyDescription(this.description);

    this.instrument = ins
    this.instrumentLabel = ins ? ins.DisplayName() : ''

    this.buySide = OperationType.Buy == msg.OperationType
    this.side = msg.OperationType

    this.limitPrice = msg.OpenPrice
    this.limitPriceToShow = null
    this.slPrice = msg.SLPrice
    this.sllPrice = msg.SLLPrice
    this.tpPrice = msg.TPPrice
    this.slPriceType = msg.SLPriceType
    this.tpPriceType = msg.TPPriceType
    this.slPriceToShow = null
    this.sllPriceToShow = null
    this.tpPriceToShow = null
    this.slPriceToShowFormatted = null
    this.tpPriceToShowFormatted = null
    this.slProfit = null
    this.tpProfit = null

    this.tif = msg.Tif
    this.tifExpireAt = msg.TifExpireAt
    this.productTypeAnal = msg.ProductType

    this.wasNotRead = msg.NotSeen
    this.isOpen = false

    this.createTime = msg.CreateTime
    this.expireTime = msg.ExpireTime
    this.tradingSignalId = msg.TradingSignalId
    this.lifeTime = DateTimeUtils.convertTicksToHHMMSS(msg.ExpireTime - Date.now())

    this.AttachmentScreenPath = msg.AttachmentScreenPath
    this.AttachmentFilePath = msg.AttachmentFilePath
    this.hasAttachments = this.AttachmentScreenPath || this.AttachmentFilePath

    if (this.AttachmentFilePath)
        this.attachExtension = this.AttachmentFilePath.substring(this.AttachmentFilePath.lastIndexOf('.'))              // get file extension
}

Idea.prototype.UrlifyDescription = function (descr)
{
    return descr.replace(UrlUtils.urlRegex, function (url)
    {
        return '<a target="_blank" class="ideaDescriptionLink" rel="noopener noreferrer" href="' + url + '">' + url + '</a>';
    })
}

export let TradingSystem = function (msg)                                              // Trading Ideas Analyst's object
{
    this.logoBytes = msg.ImageBytes
    this.login = msg.Login
    this.name = msg.Name
    this.companyName = msg.CompanyName
    this.tradingSystemID = msg.ID
    this.riskDisclosureText = msg.RiskDisclosure
    this.accepted = true
}